import {AxiosError} from 'axios';
import {
  UserGroupDetailsResponse
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import {GET_USER_GROUP_DETAILS_QUERY_KEY} from 'web-library/constants/queryKeys';
import {GET_USER_GROUP_DETAILS_URL} from 'web-library/constants/apiUrls';
import {useCustomQuery} from '../utils/useCustomQuery';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: UserGroupDetailsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  enabled: boolean;
}

export const useGetUserGroupDetails = ({onSuccess, onError, uuid, enabled}: Input) => {
  const getUserGroupDetails = async () => {
    const res = await axiosClient.get<UserGroupDetailsResponse>(GET_USER_GROUP_DETAILS_URL(uuid));
    return res.data;
  };

  return useCustomQuery(GET_USER_GROUP_DETAILS_QUERY_KEY.concat(uuid), getUserGroupDetails, {
    onSuccess,
    onError,
    enabled,
  });
};
